import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { BlacklistedConsumers } from "ui/organizms/Consumers";

const BlacklistedConsumersScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Consumers | Blacklisted'
    >
        <BlacklistedConsumers />
    </Screen>
);

export default memo(BlacklistedConsumersScreen);
